var petal = {}
petal.removeDisplayNone = function(e, id, removeSelf) {
    if (removeSelf) e.currentTarget.remove()
    document.getElementById(id).classList.remove("d-none")
}
petal.toggleDisplayNone = function(e, id) {
    e.currentTarget.classList.toggle('on')
    document.getElementById(id).classList.toggle("d-none")
}
petal.updateScroll = function() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    document.getElementById('scroll-top').classList.remove('active')
    document.getElementById('scroll-product').classList.remove('active')
    document.getElementById('scroll-concept').classList.remove('active')
    document.getElementById('scroll-petal').classList.remove('active')
    document.getElementById('scroll-atmos').classList.remove('active')
    document.getElementById('scroll-cosmos').classList.remove('active')
		document.getElementById('scroll-partner').classList.remove('active')
    document.getElementById('scroll-contactus').classList.remove('active')

    if (0 > document.getElementById('contactus').getBoundingClientRect().top - 1) {
        document.getElementById('scroll-contactus').classList.add('active')
    } else if (0 > document.getElementById('partner').getBoundingClientRect().top - 1) {
        document.getElementById('scroll-partner').classList.add('active')
    } else if (0 > document.getElementById('cosmos').getBoundingClientRect().top - 1) {
        document.getElementById('scroll-cosmos').classList.add('active')
    } else if (0 > document.getElementById('atmos').getBoundingClientRect().top - 1) {
        document.getElementById('scroll-atmos').classList.add('active')
    } else if (0 > document.getElementById('petal').getBoundingClientRect().top - 1) {
        document.getElementById('scroll-petal').classList.add('active')
    } else if (0 > document.getElementById('product').getBoundingClientRect().top - 1) {
        document.getElementById('scroll-product').classList.add('active')
    } else if (0 > document.getElementById('concept').getBoundingClientRect().top - 1) {
        document.getElementById('scroll-concept').classList.add('active')
    } else  {
        document.getElementById('scroll-top').classList.add('active')
    }
}
petal.slidePetal = function() {
    var slidePetalNumber = 1;
    setInterval(function() {
        document.getElementById("petal-slide-image-" + slidePetalNumber).classList.toggle("active")
        document.getElementById("petal-slide-indicator-" + slidePetalNumber).classList.toggle("active")
        if (slidePetalNumber === 5) {
            slidePetalNumber = 1;
            document.getElementById("petal-slide-image-" + slidePetalNumber).classList.toggle("active")
            document.getElementById("petal-slide-indicator-" + slidePetalNumber).classList.toggle("active")
            document.getElementById("petal-slide-number").innerText = "0" + slidePetalNumber
        } else {
            document.getElementById("petal-slide-image-" + (slidePetalNumber + 1)).classList.toggle("active")
            document.getElementById("petal-slide-indicator-" + (slidePetalNumber + 1)).classList.toggle("active")
            document.getElementById("petal-slide-number").innerText = "0" + (slidePetalNumber + 1)
            slidePetalNumber += 1;
        }
    }, 5000)
}
petal.slideAtmos = function() {
    var slideAtmosNumber = 1;
    setInterval(function() {
        document.getElementById("atmos-slide-image-" + slideAtmosNumber).classList.toggle("active")
        document.getElementById("atmos-slide-indicator-" + slideAtmosNumber).classList.toggle("active")
        if (slideAtmosNumber === 4) {
            slideAtmosNumber = 1;
            document.getElementById("atmos-slide-image-" + slideAtmosNumber).classList.toggle("active")
            document.getElementById("atmos-slide-indicator-" + slideAtmosNumber).classList.toggle("active")
            document.getElementById("atmos-slide-number").innerText = "0" + slideAtmosNumber
        } else {
            document.getElementById("atmos-slide-image-" + (slideAtmosNumber + 1)).classList.toggle("active")
            document.getElementById("atmos-slide-indicator-" + (slideAtmosNumber + 1)).classList.toggle("active")
            document.getElementById("atmos-slide-number").innerText = "0" + (slideAtmosNumber + 1)
            slideAtmosNumber += 1;
        }
    }, 5000)
}

jQuery(function($){
    petal.updateScroll()
    petal.slidePetal();
    petal.slideAtmos();
    var scroll = new SmoothScroll('a[href*="#"]', { speed: 1600, easing: 'easeInOutCubic', speedAsDuration: true });
    window.addEventListener("scroll", function () {
        petal.updateScroll()
    })
});
